import { useState, useEffect } from 'react';
import "./FormPasswordModal.css";
import Modal from "../shared/Modal";
import { FormExtended } from 'effno-core';
import { set } from 'react-datepicker/dist/date_utils';

type FormPasswordModalProps = {
    isOpen: boolean;
    form: FormExtended | undefined;
    onSuccess: () => void;
}

export const FormPasswordModal = ({isOpen, form, onSuccess}: FormPasswordModalProps) => {

    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string | undefined>(undefined);

    const handleSubmit = () => { 
        if (!form || !form.formSettings || form.formSettings.passwordPlain !== password) {
            setError("Incorrect Password");
            return;
        }

        onSuccess();
    }

    const handleKeyDown = (e: any) => {
        if (e.key === "Enter") {
            handleSubmit();
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={()=>{}}
            canClose={false}
            allowClickout={false}
        >
            <div className="form-password-container">
                <div className="modal-title">
                    Password Required
                </div>
                
                <input
                    type="text"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <div className="form-password-error">
                    {error}
                </div>

                <div className="modal-buttons">
                    <button
                        className="button-save"
                        onClick={handleSubmit}
                        disabled={password === ""}
                    >
                        Submit
                    </button>
                </div>
              
            </div>
      </Modal>
    )
}